class TabelDinamisUtils {
    capitalizeEachWord(str) {
        return str === null ? "" : str
            .split(" ")
            .map((w) =>
                w.substring(0, 1).toUpperCase() + w.substring(1).toLowerCase()
            )
            .join(" ");
    }

    sortArrayByStringProperty(array, property) {
        array.sort(function (a, b) {
            return a[property].localeCompare(b[property]);
        });
    }

    sortArrayByNumberProperty(array, property) {
        array.sort(function (a, b) {
            return a[property] - b[property];
        });
    }

    scrollIntoDiv(el) {
        // setTimeout(() => {
        document.getElementById(el).scrollIntoView({
            block: "start",
            behavior: "smooth",
        });
        // }, 0);
    }

    scrollToUpperMost() {
        setTimeout(function () {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }, 100);
    }

    changeNullIntoStrip(el) {
        if (el == null) {
            return "-";
        } else {
            return el;
        }
    }

    arraysEqual(a, b) {
        return (
            Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.every((val, index) => val === b[index])
        );
    }

    arrayLength(a) {
        return a.length;
    }
}

export default new TabelDinamisUtils();